import { useRouter } from 'next/router';

export const useIsItemPage = () => {
  const { asPath } = useRouter();
  const isItemPage = /^\/(text|novost)\/.+/g.test(asPath);

  return isItemPage;
};
